/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ListAnalysesOverviewScope = (typeof ListAnalysesOverviewScope)[keyof typeof ListAnalysesOverviewScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListAnalysesOverviewScope = {
  all: "all",
  own: "own",
  shared: "shared",
} as const;
